export default {
  name: 'InputOptions',
  props: ['field', 'modelValue'],
  emits: ['update:modelValue'],
  watch: {
    value: function value(_value) {
      this.$emit('update:modelValue', _value);
    }
  },
  data: function data() {
    return {
      value: this.modelValue
    };
  }
};